import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { Observable } from 'rxjs';
import { UpdateRateResponse, UpdateRatePayload } from '../../types/common';

@Injectable({
  providedIn: 'root'
})
export class UpdateRateService {

  constructor(private httpClient: HttpClient) { }

  getUpdateRate(): Observable<UpdateRateResponse> {
    const path = 'invoices/api/updateRate';
    const url = environment.SITE_URL_LOCAL + path;

    const httpOptions = {
      withCredentials: true
    };

    return this.httpClient.get<UpdateRateResponse>(url, httpOptions);
  }

  postUpdateRate(oldRate: string, newRate: string, locationID: number): Observable<any> {
    const payload: UpdateRatePayload = {
      oldRate,
      newRate,
      locationID
    };

    const path = 'invoices/api/updateRate';
    const url = environment.SITE_URL_LOCAL + path;

    const httpOptions = {
      withCredentials: true
    };

    return this.httpClient.post<any>(url, payload, httpOptions);
  }
}
